// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2D1gM","inner":"Footer_inner__1rpWr"};